import apiClient from './apiClient';

const authService = {
  /**
   * Register a new user
   */
  register: async (userData) => {
    const response = await apiClient.post('/auth/register', userData);
    if (response.data.data?.token) {
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem('authToken', response.data.data.token);
    }
    return response.data;
  },

  /**
   * Login user
   */
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password });
    if (response.data.data?.token) {
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem('authToken', response.data.data.token);
    }
    return response.data;
  },

  /**
   * Get current user
   */
  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  /**
   * Refresh token
   */
  refreshToken: async (token) => {
    const response = await apiClient.post('/auth/refresh-token', { token });
    if (response.data.data?.token) {
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem('authToken', response.data.data.token);
    }
    return response.data;
  },

  /**
   * Logout
   */
  logout: async () => {
    await apiClient.post('/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
  },

  /**
   * Get token from storage
   */
  getToken: () => {
    return localStorage.getItem('token');
  },

  /**
   * Check if user is logged in
   */
  isLoggedIn: () => {
    return !!localStorage.getItem('token');
  }
};

export default authService;
